import { AssetState, Hardware } from '../enums';
import { AssetConfig } from './config.model';
import { Event } from './event.model';
import { Timestamp, DocumentReference, FieldValue } from '@angular/fire/firestore';

export interface Asset {
  name: string;
  mac: string;
  pin: string;
  isOnline: boolean;
  otaJobId: string;
  mfg: {
    location: DocumentReference;
    state: AssetState;
    llSerial?: string;
    burnInFailureReason?: string;
    previousState: AssetState;
  };
  meta: {
    isConfigSynced: boolean;
    configAck: Timestamp;
    configUpdated: Timestamp;
    configUpdatedBy: string;
    connectivityUpdated: Timestamp | FieldValue;
    stateUpdated: Timestamp;
    mfgStateUpdated: Timestamp | FieldValue;
    mfgStateUpdatedBy: string;
    calibrationUpdated: Timestamp | FieldValue;
    calibrationUpdatedBy: string;
    telemetryUpdated: Timestamp | FieldValue;
  };
  calibration: {
    hardware: Hardware;
    pumpSpeed1: number;
    pumpSpeed2: number;
    pumpSpeed3: number;
    fanSpeed1: number;
    fanSpeed10: number;
  };
  config: AssetConfig;
  state: {
    isOff: boolean;
    isOffline: boolean;
    isDuctOff: boolean;
    ductOverride: boolean;
    isInEvent: boolean;
    pumpSpeed: number;
    fanSpeed: number;
    isPaused: boolean;
    pausedTill: Timestamp;
    firmwareVersion: string;
  };
  events: Event[];
  telemetry: {
    ipAddr: string;
    mcuTemp: number;
    wifiStrength: number;
    bootCount: number;
    deviceUptime: number;
    wifiUptime: number;
    pumpRunTime: number;
    fanRunTime: number;
    powerSupplyVoltage: number;
    pump1Current: number;
    pump2Current: number;
    fanCurrent: number;
    maxMcuTemp: number;
    minMcuTemp: number;
    maxPump1Current: number;
    minPump1Current: number;
    maxPump2Current: number;
    minPump2Current: number;
    maxFanCurrent: number;
    minFanCurrent: number;
  };
  status?: string;
}
